export const SIDENAV_ACTION_TYPES = {
    SET_MENU_PERMISSIONS: 'SET_MENU_PERMISSIONS',
    SET_SIDE_NAV_DETAILS: 'SET_SIDE_NAV_DETAILS',
    SET_SIDE_NAV_UNREAD_MESSAGE_COUNT: 'SET_SIDE_NAV_UNREAD_MESSAGE_COUNT',
};
